export enum DefinitionOwnerTypes {
  BOOKING = 'BOOKING',
  TICKET = 'TICKET',
  EVENT = 'EVENT',
}
